<template>
  <div>
    <div id="principal" class="w3-col w3-white w3-margin-top w3-padding">
      <span class="w3-button">{{titulo}}</span>

      <button
        class="w3-button w3-green w3-left"
        @click="mostrarModalInserirEmail()">
        <i class="fas fa-plus"></i>
      </button>

      <div class="w3-col w3-margin-top">
        <p class="texto-cinza w3-center" v-show="e_mails.length == 0">
          <span>Nenhum e-mail cadastrado</span>
        </p>
      </div>

      <div class="w3-col" v-show="e_mails.length > 0" v-cloak>
        <div
          :key="index" v-for="(e_mail, index) in e_mails"
          class="w3-col card-item w3-border w3-padding-small"
          style="cursor: pointer;">

          <div class="w3-col">
            <strong class="w3-text-theme">{{e_mail}}</strong>

            <div class="w3-right">
              <span @click="alterarEmail(index)">(<span class="link">alterar</span>)</span>
              <span>|</span>
              <span @click="excluirEmail(index)">(<span class="link">excluir</span>)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w3-modal" style="display: block" v-if="coleta_visivel">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <span
            @click="fechar()"
            class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

          <h5 class="w3-left w3-col m12 titulo" v-cloak>
            <b class="texto-vermelho">
              <i class="fa fa-map fa-fw"></i>
              <span>{{titulo_tela_coleta}}</span>
            </b>
          </h5>
        </header>

        <div class="w3-row-padding">
          <div class="w3-col s12 m6">
            <label>E-mail</label>
            <input
              type="text"
              ref="campoEmail"
              class="w3-input w3-border"
              placeholder="@"
              maxlength="80"
              v-model="e_mail_insercao">
          </div>
        </div>

        <footer class="w3-container conteudo-centralizado">
          <button
            class="w3-btn w3-theme"
            style="margin-top: 10px; margin-bottom: 10px;"
            @click="confirmarEmail()">
            <span>Confirmar</span>
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
  import toastr from 'toastr';
  import Biblioteca from '@/components/Repositorio/Biblioteca';

  export default {
    name: 'FrameEmails',

    props: {
      titulo: {
        type: String,
        default: 'E-mails',
        required: false
      },

      eMailsCarregar: {
        type: Array,
        default: [],
        required: false
      }
    },

    data() {
      return {
        e_mails: [],
        e_mail_insercao: '',

        titulo_tela_coleta: 'Inserir E-mail',
        coleta_visivel: false,
        indice_edicao: -1
      }
    },

    methods: {
      mostrarModalInserirEmail() {
        this.coleta_visivel = true;
        this.$nextTick(() =>this.$refs.campoEmail.focus());
      },

      confirmarEmail() {
        if (Biblioteca.stringVazia(this.e_mail_insercao)) {
          Biblioteca.exclamar('Informe o e-mail!');
          this.$nextTick(() =>this.$refs.campoEmail.focus());
          return;
        }

        if (!Biblioteca.validarEMail(this.e_mail_insercao)) {
          Biblioteca.exclamar('E-mail inválido!');
          this.$nextTick(() =>this.$refs.campoEmail.focus());
          return;
        }

        for (let i = 0; i < this.e_mails.length; i++) {
          if (i == this.indice_edicao) {
            continue;
          }

          if (this.e_mail_insercao == this.e_mails[i]) {
            Biblioteca.exclamar('E-mail já cadastrado!');
            this.$nextTick(() =>this.$refs.campoEmail.focus());
            return;
          }
        }

        if (this.indice_edicao == -1) {
          this.e_mails.push(this.e_mail_insercao);
        }
        else {
          this.e_mails[this.indice_edicao] = this.e_mail_insercao;
        }

        this.limparColetaDados();
        this.coleta_visivel = false;

        this.$emit('confirmar', this.e_mails);
      },

      limparColetaDados() {
        this.e_mail_insercao = '';
        this.indice_edicao = -1;
      },

      fechar() {
        this.coleta_visivel = false;
      },

      getEmails() {
        let retorno = [];

        for (let i = 0; i < this.e_mails.length; i++) {
          retorno.push(
            {
              ordem: i,
              e_mail: this.e_mails[i]
            }
          )
        }

        return retorno;
      },

      carregar(emails_carregar) {
        this.e_mails = JSON.parse(JSON.stringify(emails_carregar));
      },

      alterarEmail(index) {
        this.indice_edicao = index;
        this.e_mail_insercao = this.e_mails[index];
        this.coleta_visivel = true;
        this.$nextTick(() =>this.$refs.campoEmail.focus());
      },

      excluirEmail(index) {
        this.e_mails.splice(index, 1);
      }
    },

    created() {
      if ((!this.eMailsCarregar) || (this.eMailsCarregar.length <= 0)) {
        return;
      }

      this.telefones = JSON.parse(JSON.stringify(this.eMailsCarregar));
    }
  }
</script>

<style scoped>
  #principal {
    border: 1px solid #aaaaaa;
    border-radius: 10px;
  }

  .link {
    color: #9c1d1c;
    text-decoration: underline;
  }

   .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
  }

  .card-item:hover {
    border: 1px solid #bfbfbf; 
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Frames/FrameEmails.vue